import { useQuery } from '@tanstack/react-query';

export function useMapboxToken() {
  return useQuery({
    queryKey: ['mapbox-token'],
    queryFn: async (): Promise<string> => {
      const url = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/mapbox-token`;
      const res = await fetch(url, {
        headers: { apikey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY },
      });
      if (!res.ok) {
        const json = await res.json().catch(() => null);
        throw new Error(json?.error || 'Failed to load Mapbox token');
      }
      const json = await res.json();
      const token = String(json.token || '');
      if (!token.startsWith('pk.')) {
        throw new Error('Mapbox needs a public token that starts with pk.');
      }
      return token;
    },
    staleTime: 1000 * 60 * 60, // 1h
    retry: 1,
  });
}
